/** Shared auto-grow + viewport cap for inline resume textareas. */

export const TEXTAREA_MIN_HEIGHT_PX = 40
/** ~4 lines at text-sm + leading-relaxed */
export const TEXTAREA_DEFAULT_MIN_PX = 96
export const TEXTAREA_VIEWPORT_HEIGHT_RATIO = 0.55
export const TEXTAREA_VIEWPORT_MAX_PX = 560

export function maxTextareaViewportPx(
  viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 800
): number {
  return Math.min(
    Math.floor(viewportHeight * TEXTAREA_VIEWPORT_HEIGHT_RATIO),
    TEXTAREA_VIEWPORT_MAX_PX
  )
}

export function clampTextareaHeight(px: number, maxPx: number): number {
  return Math.min(Math.max(px, TEXTAREA_MIN_HEIGHT_PX), maxPx)
}

export function measureTextareaContentHeight(textarea: HTMLTextAreaElement): number {
  const previous = textarea.style.height
  textarea.style.height = 'auto'
  const measured = textarea.scrollHeight
  textarea.style.height = previous
  return measured
}

export function computeAutoTextareaHeight(
  contentHeightPx: number,
  manualHeightPx: number | null,
  maxPx: number
): number {
  const floor = Math.max(TEXTAREA_DEFAULT_MIN_PX, contentHeightPx)
  const desired =
    manualHeightPx != null ? Math.max(manualHeightPx, floor) : floor
  return clampTextareaHeight(desired, maxPx)
}

export function textareaOverflowY(
  contentHeightPx: number,
  appliedHeightPx: number
): 'auto' | 'hidden' {
  return contentHeightPx > appliedHeightPx ? 'auto' : 'hidden'
}
